"use client";
import { motion } from "framer-motion";
import { usePortfolio } from "@/hooks/usePortfolio";
import { AdminLoadingSpinner } from "@/components/admin/AdminComponents";
import Image from "next/image";


export default function SkillsSection() {
  const skills = [
    // Languages
    { id: 1, name: "Java", icon: "/skills/java.svg" },
    { id: 2, name: "Python", icon: "/skills/python.svg" },
    { id: 3, name: "JavaScript", icon: "/skills/javascript.svg" },
    { id: 4, name: "TypeScript", icon: "/skills/typescript.svg" },
    { id: 5, name: "SQL", icon: "/skills/sql.svg" },
    { id: 6, name: "HTML", icon: "/skills/html.svg" },
    { id: 7, name: "CSS", icon: "/skills/css.svg" },
    // Front-End
    { id: 8, name: "React.js", icon: "/skills/react.svg" },
    { id: 9, name: "Next.js", icon: "/skills/nextjs.svg" },
    { id: 10, name: "React Native", icon: "/skills/react-native.svg" },
    { id: 11, name: "Expo", icon: "/skills/expo.svg" },
    { id: 12, name: "Tailwind CSS", icon: "/skills/tailwind.svg" },
    // Back-End
    { id: 13, name: "Node.js", icon: "/skills/nodejs.svg" },
    { id: 14, name: "Express.js", icon: "/skills/express.svg" },
    // Cloud & Databases
    { id: 15, name: "Firebase", icon: "/skills/firebase.svg" },
    // Android Development
    { id: 16, name: "Android Studio", icon: "/skills/android-studio.svg" },
    // Other Skills
    { id: 17, name: "Git", icon: "/skills/git.svg" },
    { id: 18, name: "GitHub", icon: "/skills/github.svg" }
  ];

  return (
    <section id="skills" className="relative py-20 bg-white dark:bg-[#020817] overflow-hidden">
      <div className="absolute inset-0">
       
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Technical Skills
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-lg">
            Technologies & Tools I Work With
          </p>
        </div>

        <motion.div 
          className="flex flex-wrap justify-center gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {skills.map((skill, index) => (
            <motion.div
              key={skill.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.3,
                delay: index * 0.03,
                ease: "easeOut"
              }}
              whileHover={{ 
                scale: 1.15,
                transition: { duration: 0.2 }
              }}
              className="group relative w-20 h-20 bg-gradient-to-br from-gray-50/90 to-white/90 dark:from-gray-900/90 dark:to-gray-800/90 rounded-lg p-3 backdrop-blur-sm border border-gray-200/50 dark:border-gray-700/50 hover:border-blue-500/50 transition-all duration-300 shadow-lg hover:shadow-blue-500/20 hover:bg-gradient-to-br hover:from-blue-50/90 hover:to-white/90 dark:hover:from-blue-950/90 dark:hover:to-gray-900/90"
            >
              {/* Hover Background Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-purple-500/10 dark:from-blue-500/30 dark:to-purple-500/30 opacity-0 group-hover:opacity-100 rounded-lg transition-opacity duration-300" />
              
              {/* Skill Icon */}
              <div className="relative h-full w-full flex items-center justify-center">
                <div className="flex items-center space-x-3">
                <Image
                      src={skill.icon}
                      alt={skill.name}
                      width={28}
                      height={28}
                      className="w-8 h-8"
                      loading="lazy"
                    />
                </div>
                
                {/* Skill Name Overlay */}
                <div
                  className="absolute -bottom-8 left-1/2 -translate-x-1/2 min-w-max px-3 py-1.5 bg-gradient-to-r from-blue-50/95 to-white/95 dark:from-blue-900/95 dark:to-gray-900/95 rounded-md opacity-0 group-hover:opacity-100 transition-all duration-200 translate-y-2 group-hover:translate-y-0 shadow-lg group-hover:shadow-blue-500/20"
                >
                  <p className="text-[13px] text-gray-900 dark:text-white font-medium whitespace-nowrap">
                    {skill.name}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
} 